// @flow
import Cookies from 'js-cookie'
import type { Referrer } from 'types/referrer'
import URI from 'urijs'

export function getReferrerData(): Referrer {
  return ((Cookies.getJSON('referrer'): any): Referrer)
}

export function setReferrerCookie() {
  const uri = new URI(window.location.href)
  const query = URI.parseQuery(uri.query())
  const data = {
    ref: query.ref || undefined,
    utmCampaign: query.utm_campaign || undefined,
    utmSource: query.utm_source || undefined,
    utmMedium: query.utm_medium || undefined,
    utmTerm: query.utm_term || undefined,
    utmContent: query.utm_content || undefined,
    referrer: fetchReferrer(),
  }

  const hasData = Object.keys(data).some(key => data[key])
  if (hasData && !Cookies.get('referrer')) {
    Cookies.set('referrer', data)
  }
}

function fetchReferrer(): ?string {
  if (document.referrer) {
    const uri = new URI(document.referrer)
    // only save referrers not on the wonderschool.com domain
    if (!uri.domain().match(/\bwonderschool\.com/)) {
      return document.referrer
    }
  }
}
